// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"

// I18n-js integration with fallback handling
import I18n from 'i18n-js'
window.I18n = I18n

// Set locale dynamically from HTML lang attribute
I18n.locale = document.documentElement.lang || 'en';
I18n.defaultLocale = document.documentElement.lang || 'en';
I18n.fallbacks = true;

// Return key if translation missing (prevents page breaks)
I18n.missingTranslation = function(scope, options) {
  const fullScope = I18n.getFullScope(scope, options);
  return fullScope;
};

// Import translations dynamically (after I18n is configured)
// Dynamic import ensures I18n is defined before translations load
import('i18n/translations').catch(() => {
  console.warn('I18n translations not loaded. Run `rake i18n:js:export` to generate.');
});

// JavaScript does not load until the page is explicitly reloaded via the URL.
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "stylesheets/application";
import 'stylesheets/redactor-custom.css';
window.Cookies = require('js-cookie')

Rails.start()
// Turbolinks.start()

require("packs/analytics_tracker");
require("packs/link_tracker");
require("packs/common");
require("packs/voteup_votedown");
require("packs/threaded_comments");
require("packs/signup_validation");
require("packs/global_chat_notifications");
require("packs/gtm_ux_tracker");
require("packs/cookie_consent");


document.addEventListener('focus', (event) => {
    const replyBox = event.target;

    if (replyBox.id === 'reply_box' && replyBox.dataset.notLoggedin === "true") {
        document.querySelector('.redirect_url').value = replyBox.dataset.redirectUrl;
    }
}, true);

// Social "Email" icon opens the newsletter subscribe popup via AJAX, without rendering
// a crawlable /subscriptions/subscribe link (that path is JS-only and 406s on a plain GET).
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-social-subscribe');
    if (!trigger) return;
    event.preventDefault();
    const url = trigger.dataset.socialSubscribeUrl;
    if (url) {
        Rails.ajax({ url: url, type: 'GET', dataType: 'script' });
    }
});

ActiveStorage.start()
